import type { SceneReference, Scene } from '../types/scene';

export class SceneService {
  private sceneData: SceneReference | null = null;

  async loadSceneData(): Promise<SceneReference> {
    try {
      // Always fetch fresh data with cache busting
      const timestamp = Date.now();
      const response = await fetch(`/scene-reference.json?v=${timestamp}`, {
        cache: 'no-cache',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch scene data: ${response.status}`);
      }

      this.sceneData = await response.json();
      console.log('Fresh scene data loaded:', this.sceneData);
      return this.sceneData!;
    } catch (error) {
      console.error('Error loading scene data:', error);

      // Fallback to cached data if available
      if (this.sceneData) {
        console.warn('Using cached scene data as fallback');
        return this.sceneData;
      }

      throw error;
    }
  }

  getCurrentScene(currentTime: number): Scene | null {
    if (!this.sceneData) {
      return null;
    }

    const scenes = this.sceneData.scenes;
    let currentScene: Scene | null = null;

    for (let i = 0; i < scenes.length; i++) {
      const scene = scenes[i];
      const nextScene = scenes[i + 1];
      
      if (currentTime >= scene.time && (!nextScene || currentTime < nextScene.time)) {
        currentScene = scene;
        break;
      }
    }

    return currentScene;
  }

  getSceneDefaults(): { fadeMs: number; holdMs: number } {
    if (!this.sceneData) {
      return { fadeMs: 800, holdMs: 2000 };
    }
    
    return {
      fadeMs: this.sceneData.defaults.fadeMs,
      holdMs: this.sceneData.defaults.holdMs
    };
  }

  getImagePath(imageName: string): string {
    return `/scene-images/${imageName}`;
  }

  getAllScenes(): Scene[] {
    return this.sceneData?.scenes || [];
  }
}

export const sceneService = new SceneService();